/* eslint-disable no-bitwise */
// credit for this code to https://stackoverflow.com/a/21648508/1413689
function hexToRgba(hexString, alpha) {
  if (!/^#([A-Fa-f0-9]{3}){1,2}$/.test(hexString)) {
    throw new Error("\"".concat(hexString, "\" is not a valid CSS Hex Color value"));
  }

  var hexValues = hexString.substring(1).split('');

  if (hexValues.length === 3) {
    hexValues = [hexValues[0], hexValues[0], hexValues[1], hexValues[1], hexValues[2], hexValues[2]];
  }

  var hexValue = Number("0x".concat(hexValues.join('')));
  var redValue = hexValue >> 16 & 255;
  var greenValue = hexValue >> 8 & 255;
  var blueValue = hexValue & 255;
  return "rgba(".concat(redValue, ",").concat(greenValue, ",").concat(blueValue, ",").concat(Math.min(1, Math.max(0, alpha)), ")");
}
/* eslint-enable no-bitwise */


export { hexToRgba };
